import {Form, Row, Col, Radio, Input, Button, Card, Collapse, Modal, Select, DatePicker, Checkbox, notification, Spin} from 'antd';
import React, {useState, useEffect} from "react";
import jsonfile from '../voucher.json'
import {CisUI} from '../../../../util/CISUI'
import 'react-smart-data-table/dist/react-smart-data-table.css'
import Config from "../../../../util/config";
import axios from "../../../../util/Api";
import {Link, useHistory} from "react-router-dom";
import 'moment/locale/es-us';

const {Option} = Select;
const {TextArea} = Input;
const queryString = require('query-string');


const MVoucherDetails = (props) => {

    const formRef = React.createRef();
    const [modal, contextHolder] = Modal.useModal();
    const [showModal, setShowModal] = useState(false);
    const [form] = Form.useForm();
    const history = useHistory();

    const [company, setCompany] = useState({});
    const [user, setUser] = useState({});
    const [state, setState] = useState([]);
    const [singlestate, setSingleState] = useState({});
    const [voucherType, setvoucherType] = useState("");
    const [currency, setCurrency] = useState("");
    const [conversionRate, setConversionRate] = useState("");
    const [summary, setSummary] = useState({
        receipt : 0,
        payment : 0,
        dollar_receipt: 0,
        dollar_payment: 0
    });

    const poid = props.match.params.id;
    const isEdit = 1;

    useEffect(() => {
        getPODetails();
    }, []);

    const getPODetails = () => {
        document.getElementById("loader").style.display = "block";
        axios.get(Config.apiserver +jsonfile.urls.mview+"/"+ poid)
            .then((res) => {
                document.getElementById("loader").style.display = "none";
                //console.log(res.data);
                if (res.data.status === 1) {
                    setCurrency(res?.data?.currency);
                    setConversionRate(res?.data?.conversion_rate);
                    setState(res.data.data);
                    setCompany(res.data.company);
                    setUser(res.data.user);
                    setSingleState(res.data.data[0]);
                    setSummary({
                        receipt: res.data.totalReceipt,
                        payment: res.data.totalPayment,
                        dollar_receipt: res.data.totalDollarReceipt,
                        dollar_payment: res.data.totalDollarPayment
                    });
                    if(res.data.data[0]["debit"] > 0) {
                        setvoucherType("Receipt Voucher");
                    }
                    else {
                        setvoucherType("Payment Voucher");
                    }

                    //onPrintClick();

                }
            })
            .catch((error) => {
                console.log(error);
                document.getElementById("loader").style.display = "none";
            });
    }


    let totalPaid = 0;

    const onPrintClick = (voucher_no) => {
        // window.print();
        // <a href={"/voucherprintv1.html?id=" + row.voucher_no} target="_blank"
        //    className={"btn btn-primary btn-circle"}><i className="fas fa-print"/></a>
        window.open("/voucherprintv1.html?id="+voucher_no)
    }

    const openModal = () => {
        setShowModal(true);
    };
    const handleOk = () => {
        setShowModal(false);
    };
    const handleCancel = () => {
        setShowModal(false);
    };

    const onFinish = (values) => {
        console.log("values", values)
        let data = {
            email: values.email,
            voucher_no: poid,
        }
        console.log("values", data)
        document.getElementById("loader").style.display = "block";
        axios.post(Config.apiserver +"entries/sendvoucher", data)
            .then((res) => {
                document.getElementById("loader").style.display = "none";
                // console.log(res.data);
                if (res.data.status === 1) {
                    console.log("resData", res.data);
                    CisUI().showAlert("Success", "success", res.data.msg);
                    setShowModal(false);
                    form.resetFields();
                }
                else{
                    CisUI().showAlert("Alert", "alert", res.data.msg);
                }
                document.getElementById("loader").style.display = "none";
            })
            .catch((error) => {
                console.log(error);
                // document.getElementById("loader").style.display = "none";
            });
    }


    return (
        <Card title={"Voucher Details"} extra={
            <>
                {/*<Button id="submitbuttons" type="primary" htmlType="button">*/}
                {/*    <Link to={"../voucheredit/"+poid}>Edit</Link>*/}
                {/*</Button>*/}
                {/*<Button id="submitbuttons" type="primary" htmlType="button">*/}
                {/*    <Link to={"../voucheredit/"+poid}>Print</Link>*/}
                {/*</Button>*/}
                {/*{*/}
                {/*    isEdit === 1*/}
                {/*        ? CisUI().addAction('../../' + jsonfile.urls.list)*/}
                {/*        : CisUI().addAction('../' + jsonfile.urls.list)*/}
                {/*}*/}

                <div className="row no-print">
                    <button type="button" className="btn btn-export-excel btn-circle-md" onClick={openModal} title="Send Email">
                        <i className="fas fa-envelope"/>
                    </button>
                    <Link to={isEdit === 1 ? "../../"+jsonfile.urls.list : "../"+jsonfile.urls.list} className="btn btn-export-excel btn-circle-md" title="List">
                        <i className="fas fa-list"/>
                    </Link>
                    <button type={"button"} onClick={() => onPrintClick(singlestate.voucher_no)} className="btn btn-export-excel btn-circle-md" title="Print">
                        <i className="fas fa-print"/>
                    </button>
                    {/*<a href={"/voucherprintv1.html?id=" + singlestate.voucher_no} target="_blank" className={"btn btn-primary btn-circle"}><i className="fas fa-print"/></a>*/}
                    {
                        singlestate.is_multy === 1 ?

                            <Link
                                to={isEdit === 1 ? "../../" + jsonfile.urls2.edit + "/" + singlestate.id : "../" + jsonfile.urls.edit + "/" + singlestate.id}
                                className="btn btn-export-excel btn-circle-md" title="Edit">
                                <i className="fas fa-edit"/>
                            </Link> : <Link
                                to={isEdit === 1 ? "../../" + jsonfile.urls.edit + "/" + singlestate.id : "../" + jsonfile.urls.edit + "/" + singlestate.id}
                                className="btn btn-export-excel btn-circle-md" title="Edit">
                                <i className="fas fa-edit"/>
                            </Link>
                    }
                </div>

            </>
        }>

            {CisUI().showLoading}

            <div className="no-print row" style={{display: 'none'}}>
                <div className="col-md-12" style={{textAlign: "right"}}>
                    <a target="_blank" href={Config.baseurl+"/voucherprint.html?apiurl="+window.btoa(Config.apiserver +jsonfile.urls.mview+"/"+ poid)} className="ant-btn ant-btn-primary">
                        <i className="fa fa-print"></i> Print
                    </a>
                </div>
            </div>

            <div className="receipt-area" style={{overflow: "auto"}}>
                <div className="receipt-content">
                    <div className="invoice_header">
                        <div className="voucher-details">
                            <h1>{voucherType}</h1>
                            <div className="details">
                                <div className="title1">
                                    <div><strong>Voucher#</strong>: {singlestate.voucher_no}</div>
                                    <div><strong>Date</strong>: {CisUI().DateFormat(singlestate.date)}</div>
                                    <div><strong>Account (Cash/Bank)</strong>: {singlestate.cashaccount_number}-{singlestate.cashaccount}
                                        {
                                            singlestate.bank_account_name !== "" ? <> ({singlestate.bank_account_name}
                                            {
                                                singlestate.bank_name !== "" ? singlestate.bank_name : <></>
                                            }
                                            )</> : <></>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="logo" style={{textAlign : 'center'}}>
                            <img src="/assets/images/poc_logo.png" alt="POC" />
                            <h3>The Church of Pentecost</h3>
                            <h3>{company.name || ""}</h3>
                        </div>
                    </div>
                    <div>
                        <table className="product-list">
                            <thead>
                                <tr>
                                    <th>Particulars</th>
                                    {
                                        currency === 'USD' ?
                                        <>
                                            <th style={{width: '150px', textAlign : 'right'}}>Receipt({CisUI().getUSCurrencySymbol()})</th>
                                            <th style={{width: '150px', textAlign : 'right'}}>Payment({CisUI().getUSCurrencySymbol()})</th>
                                        </>
                                        :
                                        <>
                                            <th style={{width: '150px', textAlign: 'right'}}>Receipt({CisUI().getCurrencySymbol()})</th>
                                            <th style={{width: '150px', textAlign: 'right'}}>Payment({CisUI().getCurrencySymbol()})</th>
                                        </>
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    state.map((items,index) => {
                                        return <tr>
                                            <td>
                                                <strong>{items.account_number} - {items.account_name}</strong><br/><strong>Beneficiary:</strong> {items.beneficiary}
                                                <br/><strong>Narration : </strong> {items.details}
                                                <br /> <strong>Attachments: </strong>
                                                {
                                                    items?.attachment?.length > 0 && items?.attachment?.map((item, index) =>
                                                        // <a onClick={()=>FileOpen(item.location)}>
                                                        <a onClick={() => window.open(Config.attachement + item.location, "_blank").focus()}>
                                                            <button className="btn btn-primary btn-circle">
                                                                <i className="fas fa-folder-open"/>
                                                            </button>
                                                            {/*<span style={{paddingLeft: '5px'}}><IntlMessages id="View" /></span>*/}
                                                        </a>
                                                    )
                                                }
                                            </td>
                                            {
                                                currency === 'USD' ?
                                                    <>
                                                        <td style={{
                                                            width: '150px',
                                                            textAlign: 'right'
                                                        }}>{CisUI().getUSCurrencyFormated(items.debit > 0 ? items.dollar_amount : 0.00)}</td>
                                                        <td style={{
                                                            width: '150px',
                                                            textAlign: 'right'
                                                        }}>{CisUI().getUSCurrencyFormated(items.credit > 0 ? items.dollar_amount : 0.00)}</td>
                                                    </>
                                                    :
                                                    <>
                                                        <td style={{
                                                            width: '150px',
                                                            textAlign: 'right'
                                                        }}>{CisUI().getCurrencyFormated1(items.debit || 0)}</td>
                                                        <td style={{
                                                            width: '150px',
                                                            textAlign: 'right'
                                                        }}>{CisUI().getCurrencyFormated1(items.credit || 0)}</td>
                                                    </>
                                            }
                                        </tr>
                                    })
                                }
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td></td>
                                    {
                                        currency === 'USD' ?
                                            <>
                                                <td className="table-footer"
                                                    style={{textAlign: 'right'}}>{CisUI().getUSCurrencyFormated(summary.dollar_receipt || 0)}</td>
                                                <td className="table-footer"
                                                    style={{textAlign: 'right'}}>{CisUI().getUSCurrencyFormated(summary.dollar_payment || 0)}</td>
                                            </>
                                            :
                                            <>
                                                <td className="table-footer"
                                                    style={{textAlign: 'right'}}>{CisUI().getCurrencyFormated1(summary.receipt || 0)}</td>
                                                <td className="table-footer" style={{textAlign: 'right'}}>{CisUI().getCurrencyFormated1(summary.payment || 0)}</td>
                                            </>
                                    }
                                    </tr>
                            </tfoot>
                        </table>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <table className="benficiaryTable">
                                <tbody>
                                <tr>
                                    {/*<th><strong>{singlestate.debit > 0 ? "Received From " : "Paid To "}</strong> : {singlestate.beneficiary}</th>*/}
                                    <th><strong>Remarks/Payee</strong> : {singlestate.notes}</th>
                                    <th><strong>By Check No</strong> : {singlestate.reference}</th>
                                    <th><strong>Dated</strong> : {CisUI().DateFormat(singlestate.date)}</th>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <span><strong>{singlestate.debit > 0 ? "Received By " : "Paid By "}</strong> : </span>
                            <table className="benficiaryTable">
                                <tbody>
                                <tr>
                                    <th><strong>Prepared By</strong> : {user.hasOwnProperty("name") ? user["name"] : ""}</th>
                                    <th><strong>Authorized By </strong> :  {/*{singlestate.username}*/} </th>
                                    <th><strong>Approved By</strong> : </th>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="invoice_footer">
                        <p style={{textAlign : 'center'}}>
                            {company.name || ""}
                            {/*<br/>{(company.address_line_1 ||"")+","+(company.address_line_2 || "")+","+(company.city || "")+","+(company.state || "")+","+(company.country || "")}<br />*/}
                            {/*Phone # : {company.phone1 || ""}<br/>*/}
                            {/*Email : {company.email || ""}<br/>*/}
                            {/*Website : {Config.website || ""}<br/>*/}
                        </p>
                    </div>
                </div>
            </div>

            <Modal title="Send Email" open={showModal} onOk={handleOk} onCancel={handleCancel} footer={false}>
                <Form
                    form={form}
                    {...CisUI().formItemLayout}
                    name="input"
                    ref={formRef}
                    // className="ant-advanced-search-form"
                    onFinish={onFinish}
                >
                    {/*<Row>*/}
                    {/*    <Col lg={24}>*/}
                            <Form.Item
                                label="Sent To"
                                name="email"
                                rules={[
                                    {
                                        type: 'email',
                                    },
                                    {
                                        required: true,
                                        message: 'Field is required',
                                    }
                                ]}>
                                <Input placeholder="Ex: placeholer@mail.com"/>
                            </Form.Item>
                        {/*</Col>*/}
                        {/*<Col lg={24}>*/}
                    <div style={{ textAlign: "center", marginTop: "10px" }}>
                            <Button type="primary" htmlType="submit">
                                Submit
                            </Button>
                    </div>
                    {/*    </Col>*/}
                    {/*</Row>*/}
                </Form>
            </Modal>

        </Card>
    );
};

export default MVoucherDetails;